<template>
  <div class="full-area" :class="`question-${data.sys.contentType.sys.id}`">
    <header class="question-header align-bottom" v-if="!(data.fields.questionImage && data.fields.questionImage.fields.file.url)">
      <h2>{{data.fields.title}}</h2>
    </header>

    <header class="question-header image-question contain-image"
      v-if="data.fields.questionImage && data.fields.questionImage.fields.file.url"
    >
      <div
        class="img"
        :style="{'backgroundImage': `url(${data.fields.questionImage.fields.file.url})`}"
      ></div>
    </header>
    <content class="content delay-entry" :class="{'is-vertical': this.data.fields.isVertical}">
      <div class="emoji-wrapper">
        <div
          class="img"
          :style="{
            'backgroundImage': `url(${data.fields.fromEmoji.fields.file.url})`,
            'transform': `scale(${(5 + 2 * ((form.to - sliderValue) / form.to)) / 4 - 0.5})`
          }"
        ></div>
        <div
          class="img"
          :style="{
            'backgroundImage': `url(${data.fields.toEmoji.fields.file.url})`,
            'transform': `scale(${(5 + 2 * ((sliderValue - form.to) / form.to)) / 4})`
          }"
        ></div>
      </div>
      <div class="slider-wrapper">
        <el-slider
          :min="form.from"
          :max="form.to"
          :show-tooltip="false"
          :vertical="data.fields.isVertical"
          height="40vh"
          v-model="sliderValue"
        ></el-slider>
      </div>
    </content>
    <footer>
      <SkipQuestionButton
        :location="'locate-bottom'"
        v-on:skip="selectThis('NS/NR')"
      ></SkipQuestionButton>
    </footer>
  </div>
</template>

<script>
import chroma from 'chroma-js'

export default {
  name: 'Slider',

  props: [ 'data' ],

  components: {
    SkipQuestionButton: () => import('Components/base/SkipQuestionButton')
  },

  data () {
    return {
      sliderValue: (this.data.fields.steps || 100) / 2 + 0.001,
      form: {
        question: this.data.fields.title,
        id: this.data.sys.id,
        from: 1,
        to: this.data.fields.steps || 100,
        selected: [],
        timeToCompletion: null,
        timestamps: {
          start: new Date(),
          finish: null,
          valid: null
        }
      },
      timer: null
    }
  },

  methods: {
    selectThis (item) {
      this.form.selected = [item]
      this.form.timestamps.valid = new Date()
      this.form.timeToCompletion = this.form.timestamps.valid.getTime() - this.form.timestamps.start.getTime()
      setTimeout(() => {
        this.next()
      }, 200)
    },
    next () {
      this.form.timestamps.finish = new Date()
      this.calculateScores()
      this.$emit('next', this.form)
    },
    validInput (value) {
      // Add simple validation: if it exists, it is valid.
      if (value >= this.form.from && value <= this.form.to) {
        return true
      } else {
        return false
      }
    },
    calculateScores () {
      if (!this.data.fields.formula) {
        return
      }
      var options = []
      for (var i = 1; i <= this.data.fields.steps; i++) {
        options.push(i)
      }
      this.$store.dispatch('CALCULATE_WEIGHTED_QUESTION', {
        formula: this.data.fields.formula,
        selected: this.form.selected,
        options: options,
        maxAnswers: 1
      }).then(scores => {
        this.form.weighted = scores.weighted.slice(0)
        this.form.weightedMin = scores.weightedMin
        this.form.weightedMax = scores.weightedMax
      }).catch(err => {
        console.log('err: ', err)
      })
    }
  },

  computed: {
    chromaList () {
      return chroma.scale(['#f56c6c', '#88d8b0']).mode('lch').colors(this.data.fields.steps + 1)
    }
  },

  watch: {
    // Add a simple watch to trigger next automatically after some ms
    'form.selected': function (newVal, oldVal) {
      if (this.validInput(newVal[0]) && Number.isInteger(newVal[0])) {
        setTimeout(() => {
          this.next()
        }, 200)
      }
    },
    'sliderValue': function (newVal, oldVal) {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.form.selected = [newVal]
      }, 1500)
    }
  }
}
</script>

<style lang="scss">
</style>

<style scoped lang="scss">
  .content {
    flex-direction: column;
  }

  .slider-wrapper {
    width: 70%;
    margin: 0 auto;

    @include breakpoint($tablet) {
      width: 70%;
    }
  }

  .emoji-wrapper {
    display: flex;
    flex-direction: row;
    width: 90%;
    justify-content: space-between;
    margin-bottom: 1em;

    .img {
      width: 10vh;
      height: 10vh;
      background-size: cover;
      transition: transform 0.2s ease-in-out;
    }
  }
</style>
